export const PATHS = {
  AUTHORIZATION: '/authorization',
  PHONE_REGISTRATION: '/phone-registration',
  LOGIN: '/log-in',
  MY_HEALTH: '/myhealth',
  TEST_HOME: '/test-home',
  RESET_PASSWORD: '/reset-password'
};
